import Header from '../../components/base/Header';
import Footer from '../../components/base/Footer';

export default function About() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-pink-50 via-white to-green-50">
      <Header />
      
      <main className="container mx-auto px-4 py-12 max-w-4xl">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-pink-400 via-rose-400 to-pink-500 rounded-full mb-6 shadow-lg">
            <i className="ri-heart-3-line text-white text-4xl"></i>
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-pink-700 mb-4">
            ももちゃん畑について｜運営者プロフィール
          </h1>
        </div>

        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 mb-8">
          <div className="text-center mb-8">
            <p className="text-xl text-gray-800 leading-relaxed">
              こんにちは、ももちゃん畑の管理人 <span className="font-bold text-pink-600">ももちゃん</span> です 🌸
            </p>
          </div>

          <div className="mb-10">
            <div className="bg-gradient-to-br from-pink-50 to-rose-50 rounded-2xl p-8 border-l-4 border-pink-400">
              <h2 className="text-2xl font-bold text-pink-700 mb-4 flex items-center">
                <span className="w-10 h-10 bg-pink-100 rounded-full flex items-center justify-center mr-3">
                  <i className="ri-seedling-line text-pink-600"></i>
                </span>
                このサイトについて
              </h2>
              <p className="text-lg text-gray-800 leading-relaxed text-center font-medium mb-4">
                「毎日を少しでもやさしく、彩り豊かに」
              </p>
              <p className="text-gray-700 leading-relaxed">
                という思いでつくりました。<br />
                私は子どもと一緒に植物を育てている中で、<br />
                花や植物がくれる"癒し"や"気づき"に救われる経験をたくさんしてきました。
              </p>
            </div>
          </div>

          <div className="mb-10">
            <h2 className="text-2xl font-bold text-green-700 mb-6 flex items-center">
              <span className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center mr-3">
                <i className="ri-leaf-line text-green-600"></i>
              </span>
              このサイトでは
            </h2>
            <div className="grid md:grid-cols-2 gap-4">
              <div className="flex items-start space-x-3 p-4 bg-green-50 rounded-xl">
                <i className="ri-checkbox-circle-fill text-green-500 text-xl mt-1"></i>
                <span className="text-gray-700">花言葉</span>
              </div>
              <div className="flex items-start space-x-3 p-4 bg-green-50 rounded-xl">
                <i className="ri-checkbox-circle-fill text-green-500 text-xl mt-1"></i>
                <span className="text-gray-700">季節の花の紹介</span>
              </div>
              <div className="flex items-start space-x-3 p-4 bg-green-50 rounded-xl">
                <i className="ri-checkbox-circle-fill text-green-500 text-xl mt-1"></i>
                <span className="text-gray-700">子どもと楽しむ花育</span>
              </div>
              <div className="flex items-start space-x-3 p-4 bg-green-50 rounded-xl">
                <i className="ri-checkbox-circle-fill text-green-500 text-xl mt-1"></i>
                <span className="text-gray-700">オリジナルキャラクターのストーリー</span>
              </div>
              <div className="flex items-start space-x-3 p-4 bg-green-50 rounded-xl md:col-span-2">
                <i className="ri-checkbox-circle-fill text-green-500 text-xl mt-1"></i>
                <span className="text-gray-700">47都道府県の花文化</span>
              </div>
            </div>
            <p className="text-gray-700 leading-relaxed mt-6 text-center">
              などを、やさしい言葉で楽しく発信していきます。
            </p>
          </div>

          <div className="mb-10">
            <h2 className="text-2xl font-bold text-pink-700 mb-6 flex items-center">
              <span className="w-10 h-10 bg-pink-100 rounded-full flex items-center justify-center mr-3">
                <i className="ri-flower-line text-pink-600"></i>
              </span>
              好きな花
            </h2>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="bg-gradient-to-br from-red-50 to-pink-50 rounded-2xl overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300">
                <div className="h-48 w-full overflow-hidden">
                  <img 
                    src="https://public.readdy.ai/ai/img_res/3cbb0ffa46cf916ef4f96912815857c7.jpg"
                    alt="シクラメン"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-6 text-center">
                  <h3 className="font-bold text-gray-800 text-lg">シクラメン</h3>
                </div>
              </div>
              <div className="bg-gradient-to-br from-teal-50 to-green-50 rounded-2xl overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300">
                <div className="h-48 w-full overflow-hidden">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Beautiful%20air%20plants%20tillandsia%20collection%20with%20silvery%20green%20leaves%20and%20delicate%20structure%2C%20elegant%20botanical%20photography%2C%20soft%20natural%20lighting%2C%20simple%20clean%20white%20background%2C%20unique%20soilless%20plants%2C%20detailed%20close-up%20view%20showing%20natural%20beauty&width=400&height=300&seq=about-airplants&orientation=landscape"
                    alt="エアープランツ"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-6 text-center">
                  <h3 className="font-bold text-gray-800 text-lg">エアープランツ</h3>
                </div>
              </div>
              <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300">
                <div className="h-48 w-full overflow-hidden">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Beautiful%20white%20and%20pink%20phalaenopsis%20orchid%20flowers%20blooming%20gracefully%20with%20elegant%20petals%2C%20botanical%20photography%2C%20soft%20natural%20lighting%2C%20simple%20clean%20white%20background%2C%20luxurious%20indoor%20plant%2C%20detailed%20close-up%20view%20showing%20sophisticated%20beauty&width=400&height=300&seq=about-orchid&orientation=landscape"
                    alt="胡蝶蘭"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-6 text-center">
                  <h3 className="font-bold text-gray-800 text-lg">胡蝶蘭</h3>
                </div>
              </div>
            </div>
          </div>

          <div className="mb-10">
            <h2 className="text-2xl font-bold text-rose-700 mb-6 flex items-center">
              <span className="w-10 h-10 bg-rose-100 rounded-full flex items-center justify-center mr-3">
                <i className="ri-links-line text-rose-600"></i>
              </span>
              運営しているコンテンツ
            </h2>
            <div className="space-y-4">
              <div className="flex items-center space-x-4 p-5 bg-gradient-to-r from-pink-50 to-rose-50 rounded-xl hover:shadow-md transition-shadow duration-300">
                <div className="w-12 h-12 bg-gradient-to-br from-pink-400 to-rose-400 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-instagram-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-800">Instagram</h3>
                  <p className="text-sm text-gray-600">ももちゃん畑</p>
                </div>
              </div>
              <a 
                href="https://note.com/mo_mo_chi_100" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center space-x-4 p-5 bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl hover:shadow-md transition-shadow duration-300 cursor-pointer"
              >
                <div className="w-12 h-12 bg-gradient-to-br from-green-400 to-emerald-400 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-article-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-800">note</h3>
                  <p className="text-sm text-gray-600">花言葉と心のお話</p>
                </div>
              </a>
              <div className="flex items-center space-x-4 p-5 bg-gradient-to-r from-teal-50 to-cyan-50 rounded-xl hover:shadow-md transition-shadow duration-300">
                <div className="w-12 h-12 bg-gradient-to-br from-teal-400 to-cyan-400 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-global-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-800">ももちゃん畑ホームページ</h3>
                  <p className="text-sm text-gray-600">本サイト</p>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center pt-8 border-t border-gray-200">
            <p className="text-lg text-gray-700 leading-relaxed">
              読んでくださる皆さまに、<br />
              小さなしあわせが届きますように🌼
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
            <div className="w-16 h-16 bg-gradient-to-br from-green-400 to-emerald-400 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-mail-line text-white text-2xl"></i>
            </div>
            <h3 className="font-bold text-gray-800 text-center mb-2">お問い合わせ</h3>
            <p className="text-sm text-gray-600 text-center mb-4">
              ご質問やご意見がございましたら、お気軽にお問い合わせください
            </p>
            <div className="text-center">
              <a
                href="/contact"
                className="inline-block bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-6 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                お問い合わせフォーム
              </a>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
            <div className="w-16 h-16 bg-gradient-to-br from-pink-400 to-rose-400 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-check-line text-white text-2xl"></i>
            </div>
            <h3 className="font-bold text-gray-800 text-center mb-2">プライバシーポリシー</h3>
            <p className="text-sm text-gray-600 text-center mb-4">
              個人情報の取り扱いについてご確認ください
            </p>
            <div className="text-center">
              <a
                href="/privacy-policy"
                className="inline-block bg-pink-600 hover:bg-pink-700 text-white font-bold py-2 px-6 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                プライバシーポリシー
              </a>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
